import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  signinRedirectCallback,
  loadUserFromStorage,
  signoutRedirect,
} from "../../services/userService";
import { AuthContext } from "../../utils/authProvider";
import store from "../../redux/store";
import { toast } from "react-hot-toast";
import { useIntl } from "react-intl";
import { useLoading } from "../../components/LoadingContext";
import axios from "../../api/axiosClient";
import { handleError, errorToast } from "../../services/serviceBase";

function SigninOidc() {
  const navigate = useNavigate();
  const userManager = useContext(AuthContext);
  const intl = useIntl();
  const { setLoading } = useLoading();

  const checkIfUserIsAllowed = (from) => {
    setLoading(true);
    axios
      .get("/security")
      .then((response) => {
        setLoading(false);
        navigate(from, { replace: true });
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl, () => {
          errorToast(error, intl);
          const errorTimeout = setTimeout(
            () => signoutRedirect(userManager),
            2500
          );
          return () => clearTimeout(errorTimeout);
        });
      });
  };

  useEffect(() => {
    async function SigninAsync() {
      try {
        await signinRedirectCallback(userManager);
      } catch {
        // intentionally empty; the compiler reaches this point when you click the "Back" button
      }

      // Send them back to the page they tried to visit when they were
      // redirected to the login page. Use { replace: true } so we don't create
      // another entry in the history stack for the login page. This means that
      // when they get to the protected page and click the back button, they
      // won't end up back on the login page, which is also really nice for the
      // user experience.
      let from = sessionStorage.getItem("from");
      if (from) {
        sessionStorage.removeItem("from");
      } else {
        from = "/";
      }

      var user = await loadUserFromStorage(store, userManager);
      if (user == null) {
        toast.error(intl.formatMessage({ id: "Login.NoUserSelected" }));
        const errorTimeout = setTimeout(
          () => signoutRedirect(userManager),
          2500
        );
        return () => clearTimeout(errorTimeout);
      }

      checkIfUserIsAllowed(from);
    }

    SigninAsync();
  }, [navigate]);

  return <div>Redirecting...</div>;
}

export default SigninOidc;
